// import React from "react";
// import * as motion from "motion/react-client";
// import "./Button.css";
//
// interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
//     variant?: "default" | "darkMode"
//     size?: "sm" | "md" | "lg";
//     backgroundColor?: string;
//     border?: string;
//     children?: React.ReactNode;
// }
//
// export const Button: React.FC<ButtonProps> = ({
//                                                   variant = "default",
//                                                   backgroundColor = "#3b82f6",
//                                                   children
//     }: ButtonProps) => {
//     const variantClasses = {
//         default: "btn-default",
//         darkMode: "dark-mode-button"
//     };
//     return <motion.button className={`${variantClasses[variant]}`}
//                           style={{ backgroundColor: backgroundColor }}
//                           initial={{ opacity: 0, y: 30 }}
//                           animate={{ opacity: 1, y: 0 }}
//                           transition={{ delay: 0.2 }}
//     >{children}</motion.button>;
// };

import React from "react";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: "default" | "ghost" | "outline" | "secondary";
    size?: "sm" | "md" | "lg";
}

export const Button: React.FC<ButtonProps> = ({
                                                  variant = "default",
                                                  size = "md",
                                                  className,
                                                  ...props
                                              }) => {
    const base = "rounded px-4 py-2 font-semibold transition-colors";
    const variantClasses = {
        default: 'bg-blue-500 text-white hover:bg-orange-400',
        ghost: 'bg-transparent hover:bg-orange-400',
        outline: 'border border-blue-400 hover:bg-orange-400',
        secondary: 'bg-gray-500 text-white hover:bg-orange-400',
    };
    const sizeClasses = {
        sm: "text-sm",
        md: "text-base",
        lg: "text-lg",
    };

    return <button className={`${base} ${variantClasses[variant]} ${sizeClasses[size]} ${className || ""}`} {...props} />;
};